import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const ListItem = ({
  children,
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('list-item')
}, ({
  getDataTaktAttributes
}) => /*#__PURE__*/React__default.createElement("li", _extends({}, getDataTaktAttributes(), rest), children));
const StyledListItem = /*#__PURE__*/styled(ListItem).withConfig({
  componentId: "sc-storm-ui-40025937__sc-1r8eex-0"
})(["font:", ";color:", ";", ""], ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.text.color.default, isMobile(css(["font:", ";"], ({
  theme
}) => theme.font.text.base.mobile)));
StyledListItem.displayName = 'ListItem';

export { StyledListItem as S };
//# sourceMappingURL=ListItem-p1cGWR6p.js.map
